import { render, staticRenderFns } from "./UpdateOrgGroup.vue?vue&type=template&id=5a211b50&"
import script from "./UpdateOrgGroup.vue?vue&type=script&lang=js&"
export * from "./UpdateOrgGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UpdateOrgGroup.vue"
export default component.exports